import Config from '@skin_config';
import _ from 'lodash';

export const extractEnabledPaths = _.memoize(() => {
  const paths = new Set();

  Config.routes.flatMap((item) => {
    if (item.nestedItems && item.nestedItems.length) return item.nestedItems;
    return item;
  }).forEach((item) => {
    const pathSplitten = item.url?.split('/');
    if (item.enabled) {
      paths.add(pathSplitten?.[0] || item.urlType);
      paths.add(pathSplitten?.[pathSplitten.length - 1] || item.urlType);
    }
  });

  return paths;
});

export const filterRoutes = (routes, allowedPaths) => routes.map((route) => {
  if (!route.children) return route;

  const filteredChildren = route.children.filter((child) => {
    const childPath = child.path?.split('/')[0];
    const keepAlways = child.path?.endsWith('*') || child.index;

    return keepAlways || (childPath && allowedPaths.has(childPath));
  });

  return {
    ...route,
    children: filteredChildren,
  };
});
